import rtk /* , { select } */ from 'rtk';
import { createSelectorHooks } from 'rtk/react';
import { name } from './constants';
const { createSelectors } = rtk(name);

export const subId = ({ event, type, id }) =>
  event === 'new' ? `${event}-${type}` : `${event}-${type}-${id}`;

const selectors = createSelectors({
  empty_subscriptions: [
    (state) => state[name].subscriptions,
    (subscriptions) =>
      Object.values(subscriptions)
        .filter(({ references }) => Object.values(references).length === 0)
        .map(({ identifier }) => identifier),
  ],
  identifier: (state, subscription) =>
    state[name].subscriptions[subId(subscription)].identifier,
  actions: [
    (state, subscription) => state[name].subscriptions[subId(subscription)],
    (subscriptionObj) => Object.values(subscriptionObj.references || {}),
  ],
});

// RTK-AUTOEXPORT
// ---- selectors ---------
export const { selectEmptySubscriptions, selectIdentifier, selectActions } =
  selectors;
export const { useEmptySubscriptions, useIdentifier, useActions } =
  createSelectorHooks(selectors);
